<template>
	<el-tooltip class="item smartTip-text" effect="light"  placement="top-start" v-show="curWebsite.type !=6">
		<i class="el-icon-question" style="color:cornflowerblue;margin-left: 5px;"></i>
		<div slot="content" class="list_tips" v-if="curWebsite.type!=4"> 
			<!-- <p>以商招商{{xstext}}：本地及附近城市所有A股上市公司的供应商和客户</p> -->
			<p>以商招商{{xstext}}：本地重点企业的供应商和客户</p> 
			<p>资本招商{{xstext}}：获得融资有较强投资意愿的企业名单</p> 
			<p>企业投资窗口期：投资意愿强，处于投资窗口期的企业名单</p>
			<p>产业投资窗口期：发展潜力大、处于投资窗口期的产业及相关企业</p>
			<p v-if="!demonstrate">选址项目{{xstext}}：精选优质的选址项目 </p>
			<p>重点区域招商{{xstext}}：在相关区域有过投资行为或者有客户供应商在该区域的企业名单</p>
			<p>热点产业的重点企业{{xstext}}：根据当前招商领域热点产业筛选出来的重点企业名单</p>
			<p>重点城市的重点产业{{xstext}}：全国重点城市发展较好的战略新兴产业及其企业名单</p> 
			<p>重点产业的重点城市{{xstext}}：全国六大战略新兴产业发展较好的重点城市及其企业名单</p>
			<p>优质上市公司招商{{xstext}}：上市公司名单，可以通过各种指标筛选</p> 
			<p>排行榜{{xstext}}：基于中投大数据的企业排行榜</p>
			<!-- 优质上市公司招商线索（选城市）：根据不同指标选取重点城市发展较好的战略新兴产业及上市公司名单
			优质上市公司招商线索（选产业）：根据不同指标选取战略新兴产业发展较好的城市及上市公司名单 -->
			<p>重点榜单{{xstext}}：各机构发布的榜单，榜单内个别企业由于存在“已注销”等特殊情况，已被剔除</p> 
		</div> 
		<div slot="content" class="list_tips" v-if="curWebsite.type==4">
			<p>产业链金融：本地重点企业的供应商和客户</p>
			<p>投贷联动融资线索：获得融资有较强投资信贷意愿的企业名单</p>
			<p>企业投资（融资）窗口期：投资意愿强，处于投资（融资）窗口期的企业名单</p>
			<p>产业投资（融资）窗口期：发展潜力大、处于投资（融资）窗口期的产业及相关企业</p>
			<p>风口产业的重点企业：根据当前风口产业筛选出来的重点企业名单</p>
			<p>优质上市公司筛选器：上市公司名单，可以通过各种指标筛选</p>
			<p>企业投资排行榜：基于中投大数据的企业投资行为排行榜</p>
			</div>
	</el-tooltip>
</template>

<script>
	export default {
		name: 'cluetips',
		props:{
			searchtype:{
				type: Number,
				default: 0,
			}
		},
		data: function(){
			return{
					iszsdn:this.$api.iszsdn(),xstext:"", 
					curWebsite:this.$api.getWebsiteType(),
					demonstrate:this.$api.demonstrate(),
			};
		},
		created() {
			 if(this.curWebsite.type == 1){this.xstext="线索"; }; 
		},
	 
		mounted() {
		 
		}
	}
</script>

<style>
	.a-red{
		color:#c00;
	}
	.right_boxtitle .el-tooltip{
		position: relative;top: 10px;
	}
</style>